import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:database-outline',
      order: 20,
      title: '主要功能',
    },
    name: 'AdKeyFeatures',
    path: '/key-features',
    children: [
      {
        name: 'AdCustomerList',
        path: '/customer-list',
        component: () => import('#/views/key-features/customer-list/index.vue'),
        meta: {
          icon: 'mdi:customer-service',
          title: '客户管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdCustomerSubAccount',
        path: '/customer-sub-account',
        component: () =>
          import('#/views/key-features/customer-sub-account/index.vue'),
        meta: {
          icon: 'mdi:account-key-outline',
          title: '客户子账号管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdAgentManagement',
        path: '/agent-management',
        component: () =>
          import('#/views/key-features/agent-management/index.vue'),
        meta: {
          icon: 'mdi:clipboard-user-outline',
          title: '代理管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdAgentReconciliation',
        path: '/agent-reconciliation',
        component: () =>
          import('#/views/key-features/agent-reconciliation/index.vue'),
        meta: {
          icon: 'mdi:file-compare',
          title: '代理+我司数据核对',
          keepAlive: true,
        },
      },
      {
        name: 'AdIntroducer',
        path: '/introducer',
        component: () => import('#/views/key-features/introducer/index.vue'),
        meta: {
          icon: 'mdi:account-arrow-right-outline',
          title: '介绍人和吐点',
          keepAlive: true,
        },
      },
      // 返点配置
      {
        name: 'AdRebateConfig',
        path: '/rebate-config',
        component: () => import('#/views/key-features/rebate-config/index.vue'),
        meta: {
          icon: 'mdi:settings-outline',
          pageKey: 'AdRebateConfig',
          title: '返点配置',
          keepAlive: true,
        },
      },
      {
        name: 'AdOtherFee',
        path: '/other-fee',
        component: () => import('#/views/key-features/other-fee/index.vue'),
        meta: {
          icon: 'mdi:cash-minus',
          pageKey: 'AdOtherFee',
          title: '其他扣费',
          keepAlive: true,
        },
      },
      {
        name: 'AdRegionTaxFee',
        path: '/region-tax-fee',
        component: () =>
          import('#/views/key-features/region-tax-fee/index.vue'),
        meta: {
          icon: 'mdi:calculator',
          title: '地区税费',
          keepAlive: true,
        },
      },
      {
        name: 'AdExportCenter',
        path: '/export-center',
        component: () => import('#/views/key-features/export-center/index.vue'),
        meta: {
          icon: 'mdi:tray-arrow-down',
          title: '导出中心',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
